import React from 'react';
import { compose } from 'recompose';
import styled, { StylesProps } from '../../../../../../lib/styles';
import theme, { Brand, Color } from '../../../../../../lib/theme';

import explainerProductStyles from './ExplainerProduct_styles';
import Typography from '../../../../../../components/presentational/Typography';
import Image from '../../../../../../components/presentational/Image';
import Button from '../../../../../../components/presentational/Button';
import Icon from '../../../../../../components/presentational/Icon';

const { logos } = theme;

export interface ExplainerProductProps {
  brand?: Brand;
  backgroundColor?: Color;
  content: string;
  imageURL: string;
  title?: string;
  buttonText?: string;
  href?: string;
  hideLogo?: boolean;
  shrink?: boolean;
}

const ExplainerProduct = ({
  imageURL,
  backgroundColor = 'primary',
  content,
  brand = 'sas',
  href,
  hideLogo,
  title,
  buttonText,
  shrink,
  styles,
}: ExplainerProductProps & StylesProps<typeof explainerProductStyles>) => (
  <a className={styles.product} href={href}>
    <Image
      className={styles.productImage}
      lazy
      src={imageURL}
      resizeHeight={shrink ? 200 : 250}
      height={shrink ? 200 : 250}
      resizeFit={'crop'}
    />

    <div className={styles.productInner}>
      {!hideLogo && (
        <Image
          lazy
          src={
            logos[brand][
              backgroundColor.startsWith('primary') ? 'secondary' : 'primary'
            ]
          }
          height={shrink ? 20 : 25}
        />
      )}

      {title && (
        <Typography>
          <h3>{title}</h3>
        </Typography>
      )}

      <Typography
        color={backgroundColor.startsWith('primary') ? 'white' : 'black'}
        dangerouslySetInnerHTML={{ __html: content }}
      />

      {buttonText && (
        <Button>
          <span>{buttonText}</span>
          <Icon icon={'arrow_forward'} className={styles.buttonIcon} />
        </Button>
      )}
    </div>
  </a>
);

export default compose(styled(explainerProductStyles))(ExplainerProduct);
